import React from 'react';
import DataTableRow from "../DataTableRow";
import DataTableCell from "../DataTableCell";

const DataTableEmptyState = ({ columns }) => {
  return (
    <DataTableRow>
      <DataTableCell colSpan={columns.length}>
        <div className="empty-state py-4" role="status">
          <img
            src="/assets/images/emptyStateTable.png"
            alt=""
            className="empty-state__image"
            aria-hidden="true"
          />
          <p className="empty-state__title">No Records Found</p>
          <p className="empty-state__message">
            There is nothing to display yet. Try adjusting your search or filters.
          </p>
        </div>
      </DataTableCell>
    </DataTableRow>
  )
}

export default DataTableEmptyState
